import { css } from '@emotion/react'

const S = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
  `,

  img: css`
    width: 45px;
    height: 45px;
  `,

  text: css`
    margin-top: 24px;
    text-align: center;
  `,
}

export default S
